import {InjectionToken} from '@angular/core'
import {DistributorEmbeddedService} from '@service/distributors/distributor.embedded.service'
import {DistributorService} from '@service/distributors/distributor.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `DistributorService`.
 *
 * @description
 * Devuelve `DistributorEmbeddedService` en modo embebido y
 * `DistributorService` en modo standalone. `DistributorService` expone
 * las operaciones de dominio sobre distribuidores (listado, búsqueda,
 * relación con pedidos y transferencias).
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `DistributorService`.
 */
export function providerDistributorServiceFactory(embeddedClientService: EmbeddedClientService) {
  if (embeddedClientService.isEmbeddedFunction()) {
    return new DistributorEmbeddedService()
  }
  return new DistributorService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `DistributorService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerDistributorServiceFactory}.
 */
export const DistributorServiceToken = new InjectionToken<DistributorService>('Distributor')
